import { Breadcrumbs as MUIBreadcrumbs, Typography } from '@mui/material';
import { fontWeight } from '@app/theme/typography';
import { Link, styled } from '@mui/material';
import { palette } from '@app/theme/palette';

export const BreadcrumbsRoot = styled(MUIBreadcrumbs)`
  li {
    padding-right: 0px;
  }
  li.MuiBreadcrumbs-separator {
    line-height: 20.25px;
    margin-right: 5px;
    margin-left: 5px;
  }
`;

export const BreadcrumbLink = styled(Link)`
  align-items: center;
  color: ${palette.custom.darkGrey};
  cursor: pointer;
  display: flex;
  font-size: 13.5px;
  font-weight: ${fontWeight.bold};
  letter-spacing: 0.675px;
  line-height: normal;
  text-decoration: none;
  text-transform: uppercase;
  width: fit-content;
  :hover {
    text-decoration: underline;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    :hover {
      text-decoration: none;
    }
  }
`;

export const BreadcrumbText = styled(Typography)`
  color: ${palette.custom.darkGrey}66;
  letter-spacing: 0.675px;
  line-height: normal;
  font-size: 13.5px;
  font-weight: ${fontWeight.bold};
  margin-bottom: 0px;
  text-transform: uppercase;
`;
